var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHdot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 31,
    viewBox: "0 0 139 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 27.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 15.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 3.5,
    r: 3.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdot1);
export default __webpack_public_path__ + "static/media/Hdot1.7780506251618e26db5c7490595621d5.svg";
export { ForwardRef as ReactComponent };